<script setup>
import { FormKitMessages } from '@formkit/vue'
const props = defineProps({
  label: {
    type: String,
    required: false,
    default: '',
  },
  theme: {
    type: Object,
    required: false,
    default() {
      return {
        month: {
          classes: 'small-4',
        },
        day: {
          classes: 'small-4',
        },
        year: {
          classes: 'small-4',
        },
      }
    },
  },
  yearRange: {
    type: Object,
    required: false,
    // Default is array of years starting with current year until 5 years ahead
    default() {
      return Array.from(Array(5).keys()).reduce(
        (acc, curr, index) =>
          Object.assign(acc, {
            [moment().year() + index]: moment().year() + index,
          }),
        {},
      )
    },
  },
  initialDate: {
    type: Object,
    required: false,
    default() {
      return {
        month: moment().month() + 1,
        day: moment().date(),
        year: moment().year(),
      }
    },
  },
})

const day = ref(props.initialDate.day)
const month = ref(props.initialDate.month)
const year = ref(props.initialDate.year)

function todayOrAfter(value) {
  return (
    Array.isArray(value) &&
    moment(
      Object.assign({}, value[0], {
        // Month always zero-based in moment, so subtract 1
        month: Number(value[0].month) - 1,
      }),
    ).isSameOrAfter(moment().startOf('day'))
  )
}
function atLeastTwentyOneYearsAgo(value) {
  const currentDate = moment()
  if (!Array.isArray(value)) {
    return false
  }
  const date = moment(
    Object.assign({}, value[0], {
      // Month always zero-based in moment, so subtract 1
      month: Number(value[0].month) - 1,
    }),
  )
  const twentyOneYearsAgo = currentDate.subtract(21, 'years')
  return twentyOneYearsAgo.isAfter(date)
}
</script>

<template>
  <FormKit
    type="group"
    :validation-messages="{
      todayOrAfter: 'Error: Date must be today or later.',
      atLeastTwentyOneYearsAgo: 'Error: You must be at least 21 years old.',
    }"
    :validation-rules="{
      todayOrAfter: ({ value }) => todayOrAfter(value),
      atLeastTwentyOneYearsAgo: ({ value }) => atLeastTwentyOneYearsAgo(value),
    }"
    v-bind="$attrs"
  >
    <fieldset>
      <div class="row">
        <div v-if="props.label" class="columns">
          <label for="input_6">{{ props.label }}</label>
        </div>
        <div :class="'columns ' + theme.month.classes">
          <FormKit
            :formulate-value="month"
            type="select"
            name="month"
            :options="
              Array.from(Array(12).keys()).reduce(
                (acc, curr, index) =>
                  Object.assign(acc, {
                    [index + 1]: $moment().month(index).format('MMMM'),
                  }),
                {},
              )
            "
            placeholder="Month"
            validation="required"
            :input-class="({ hasErrors }) => (hasErrors ? 'error' : '')"
          />
        </div>
        <div :class="'columns ' + theme.day.classes">
          <FormKit
            :formulate-value="day"
            type="select"
            name="day"
            :options="
              Array.from(Array(31).keys()).reduce(
                (acc, curr, index) =>
                  Object.assign(acc, {
                    [index + 1]: index + 1,
                  }),
                {},
              )
            "
            placeholder="Day"
            validation="required"
            :input-class="({ hasErrors }) => (hasErrors ? 'error' : '')"
          />
        </div>
        <div :class="'columns ' + theme.year.classes">
          <FormKit
            :formulate-value="year"
            type="select"
            name="year"
            :options="yearRange"
            placeholder="Year"
            validation="required"
            :input-class="({ hasErrors }) => (hasErrors ? 'error' : '')"
          />
        </div>
      </div>
    </fieldset>
    <FormKitMessages />
  </FormKit>
</template>
